import { render } from "./HeroBannerGeneral.vue?vue&type=template&id=23cde60a&scoped=true"
import script from "./HeroBannerGeneral.vue?vue&type=script&lang=js"
export * from "./HeroBannerGeneral.vue?vue&type=script&lang=js"

import "./HeroBannerGeneral.vue?vue&type=style&index=0&id=23cde60a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cde60a"]])

export default __exports__